import React, { Component } from 'react';
import Constants from '../../Config/Config';

class Backing extends Component {

  constructor(props) {
    super(props);
    this.getSelectedBacking = this.getSelectedBacking.bind(this);
  }

  componentDidUpdate(prevProps) {
    const backingsChanged = (prevProps.backings !== this.props.backings) || (Array.isArray(this.props.backings) && Array.isArray(prevProps.backings) && prevProps.backings.length !== this.props.backings.length);
    const dimsOrSelectionChanged = prevProps.selectedBacking !== this.props.selectedBacking ||
      prevProps.frameFullDimension !== this.props.frameFullDimension ||
      prevProps.selectedTopMatValueInCM !== this.props.selectedTopMatValueInCM ||
      prevProps.selectedMiddleMatValueInCM !== this.props.selectedMiddleMatValueInCM ||
      prevProps.selectedBottomMatValueInCM !== this.props.selectedBottomMatValueInCM ||
      prevProps.selectedMatSize !== this.props.selectedMatSize;
    if (dimsOrSelectionChanged || (backingsChanged && this.props.backings && this.props.backings.length > 0)) {
      this.getSelectedBacking();
    }
  }

  componentDidMount() {
    if (this.props.backings && this.props.backings.length > 0 && this.props.selectedBacking != null) {
      this.getSelectedBacking();
    }
  }

  getSelectedBacking = () => {
    const { backings, selectedBacking, selectedMatSize, frameFullDimension } = this.props;

    var topMatWidth = 0;
    var middleMatWidth = 0;
    var bottomMatWidth = 0;

    if (parseFloat(selectedMatSize) !== 0) {
      topMatWidth = this.props.selectedTopMatValueInCM || 0;
    }

    if (parseFloat(selectedMatSize) === 2 || parseFloat(selectedMatSize) === 3) {
      middleMatWidth = this.props.selectedMiddleMatValueInCM || 0;
    }

    if (parseFloat(selectedMatSize) === 3) {
      bottomMatWidth = this.props.selectedBottomMatValueInCM || 0;
    }

    // Same formula as Glass: unitPrice * (frameFullDimension + (top*4 + middle*4 + bottom*4))
    const frameFullDimensionNum = parseFloat(frameFullDimension) || 0;
    const matDimension = (parseFloat(topMatWidth) * 4) + (parseFloat(middleMatWidth) * 4) + (parseFloat(bottomMatWidth) * 4);
    const dimension = frameFullDimensionNum + matDimension;

    const backingsList = Array.isArray(backings) ? backings : (backings && backings.toJS ? backings.toJS() : []);
    if (backingsList.length > 0 && selectedBacking != null && selectedBacking >= 0) {
      const backing = backingsList[selectedBacking];
      if (backing) {
        // backing.json: cost is unit price per dimension (e.g. "0" or "0.19")
        const costVal = backing.cost != null ? backing.cost : backing.price;
        const unitPrice = parseFloat(costVal) || 0;
        const total = (unitPrice * dimension).toFixed(2);
        this.props.dispatch({
          type: 'SET_STATE',
          state: {
            backingTotal: total,
            selectedBackingName: backing.type != null ? backing.type : (backing.get ? backing.get('type') : '')
          }
        });
        return;
      }
    }
    this.props.dispatch({
      type: 'SET_STATE',
      state: { backingTotal: '0.00' }
    });
  };

  render() {
    const { backingTotal, selectedBackingName } = this.props;
    if (selectedBackingName === null || selectedBackingName === undefined) {
      return null;
    }
    return (
      <tr>
        <th>Backing</th>
        <td>{selectedBackingName}</td>
        <td>{Constants.Currency + backingTotal}</td>
      </tr>
    );
  }
}

export default Backing;
